import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const MagnifyingGlassIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        className="Icon magnifying-glass"
        {...props}
    >
        <path
            fill="#FFF"
            d="M7.5 2a5.5 5.5 0 0 1 4.205 9.045.477.477 0 0 1 .149.101l2 2a.5.5 0 0 1-.708.708l-2-2a.499.499 0 0 1-.103-.15A5.5 5.5 0 1 1 7.5 2zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 2a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H8v1.5a.5.5 0 0 1-1 0V8H5.5a.5.5 0 0 1 0-1H7V5.5a.5.5 0 0 1 .5-.5z"
        />
    </svg>
);
const Memo = memo(MagnifyingGlassIcon);
export default Memo;
